import { render, staticRenderFns } from "./DocumentTypes.vue?vue&type=template&id=e3e4c636&scoped=true&"
import script from "./DocumentTypes.vue?vue&type=script&lang=js&"
export * from "./DocumentTypes.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypes.vue?vue&type=style&index=0&id=e3e4c636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e4c636",
  null
  
)

export default component.exports